module.exports = __webpack_public_path__ + "media/GoogleStore.49dc322a.svg";